import { useNavigate } from "react-router-dom";
import { Button } from "@/styles/ui/button";
import { FrownIcon, HomeIcon } from "lucide-react";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full px-6 py-12 text-center">
        <div className="flex flex-col items-center">
          <FrownIcon className="w-[120px] h-[120px] mb-4 text-gray-900" />
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            페이지를 찾을 수 없습니다
          </h2>
          <p className="text-gray-500 mb-8">
            요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          </p>
        </div>

        <div className="flex flex-row gap-4">
          <Button
            onClick={() => navigate("/")}
            className="w-full shadow-none border bg-white"
          >
            <HomeIcon className="w-4 h-4 mr-2" />
            홈으로 돌아가기
          </Button>
        </div>
      </div>
    </div>
  );
};
